import { Link } from "react-router-dom";
import { Article } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const category = categories.find((c) => c.slug === article.category);

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300/60 transition-all duration-300 cursor-pointer"
    >
      <div className="relative overflow-hidden aspect-[4/3]">
        <img
          src={article.image}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block px-2.5 py-1 text-xs font-medium bg-background-50/90 text-foreground-700 rounded-full backdrop-blur-sm">
            {category?.name || article.category}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span>{article.date}</span>
          <span>{article.readTime}</span>
        </div>
      </div>
    </Link>
  );
}